import api from '@/modules/api'
import Countdown from 'countdown-js'
import moment from 'moment'

export default {
  state: {
    appStoreSetting: {},
    iconBackgroundImages: {},
    splashBackgroundImages: {},
    pubslishiOS: false,
    publishAndroid: false,
    subscriptionConfiguration: {},
    appCategories: {},
    appCountries: {},
    appPath: '',
    previousComponent: '',
    currentComponent: '',
    screenShotControlNo: null,
    iconImageUrl: '',
    splashScreenUrl: '',
    svgIconUrl: '',
    addAppName: true,
    Ischanged: false,
    IsAppInfochanged: false,
    appIconUrl: '',
    appSplashUrl: '',
    publishingAppData: '',
    Leftdays: '',
    Lefthours: '',
    Leftminutes: '',
    Leftseconds: '',
    isCorrectionPeriod: false,
    scrollToView: '',
    publishProcessstatus: 0,
    LastStartPublishingDate: '',
    Countdowntimer: '',
    IsappIdvalid: true,
    IsappNamevalid: true
  },
  getters: {
    appStoreSetting: state => state.appStoreSetting,
    iconBackgroundImages: state => state.iconBackgroundImages,
    splashBackgroundImages: state => state.splashBackgroundImages,
    pubslishiOS: state => state.pubslishiOS,
    publishAndroid: state => state.publishAndroid,
    subscriptionConfiguration: state => state.subscriptionConfiguration,
    appCategories: state => state.appCategories,
    appCountries: state => state.appCountries,
    appPath: state => state.appPath,
    previousComponent: state => state.previousComponent,
    currentComponent: state => state.currentComponent,
    screenShotControlNo: state => state.screenShotControlNo,
    iconImageUrl: state => state.iconImageUrl,
    splashScreenUrl: state => state.splashScreenUrl,
    svgIconUrl: state => state.svgIconUrl,
    addAppName: state => state.addAppName,
    Ischanged: state => state.Ischanged,
    IsAppInfochanged: state => state.IsAppInfochanged,
    appIconUrl: state => state.appIconUrl,
    appSplashUrl: state => state.appSplashUrl,
    publishingAppData: state => state.publishingAppData,
    Leftdays: state => state.Leftdays,
    Lefthours: state => state.Lefthours,
    Leftminutes: state => state.Leftminutes,
    Leftseconds: state => state.Leftseconds,
    isCorrectionPeriod: state => state.isCorrectionPeriod,
    scrollToView: state => state.scrollToView,
    publishProcessstatus: state => state.publishProcessstatus,
    LastStartPublishingDate: state => state.LastStartPublishingDate,
    Countdowntimer: state => state.Countdowntimer,
    IsappIdvalid: state => state.IsappIdvalid,
    IsappNamevalid: state => state.IsappNamevalid
  },
  mutations: {
    setIsappIdvalid (state, payload) { state.IsappIdvalid = payload },
    setIsappNamevalid (state, payload) { state.IsappNamevalid = payload },
    setpublishProcessstatus (state, payload) {
      if (payload === 0) {
        state.publishProcessstatus = 0
      } else { state.publishProcessstatus = state.publishProcessstatus + payload }
    },
    setscrollToView (state, payload) { state.scrollToView = payload },
    setLastStartPublishingDate (state, payload) { state.LastStartPublishingDate = payload },
    setLeftdays (state, payload) { state.Leftdays = payload },
    setLefthours (state, payload) { state.Lefthours = payload },
    setLeftminutes (state, payload) { state.Leftminutes = payload },
    setLeftseconds (state, payload) { state.Leftseconds = payload },
    setappIconUrl (state, payload) { state.appIconUrl = payload },
    setappSplashUrl (state, payload) { state.appSplashUrl = payload },
    setAppStoreSetting (state, payload) { state.appStoreSetting = payload },
    setIconBackgroundImages (state, payload) { state.iconBackgroundImages = payload },
    setSplashBackgroundImages (state, payload) { state.splashBackgroundImages = payload },
    setiOSPublish (state, payload) { state.pubslishiOS = payload },
    setAndroidPublish (state, payload) { state.publishAndroid = payload },
    setVersionMajorNumber (state, payload) { state.subscriptionConfiguration.VersionMajorNumber = state.subscriptionConfiguration.VersionMajorNumber + 1 },
    setVersionMinorNumber (state, payload) { state.subscriptionConfiguration.VersionMinorNumber = 0 },
    setSubscriptionConfiguration (state, payload) {
      state.subscriptionConfiguration = payload
    },
    setSelectedIcon (state, payload) { state.subscriptionConfiguration.AppSplashscreenSelectedIcon = payload },
    setSelectedSplashScreen (state, payload) { state.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage = payload },
    setAppCategories (state, payload) { state.appCategories = payload },
    setAppCountries (state, payload) { state.appCountries = payload },
    dummyMutation (state, payload) { },
    setDummyMutation (state, payload) { state.appPath = payload },
    setComponentValues (state, payload) {
      state.previousComponent = payload.previousComponent
      state.currentComponent = payload.currentComponent
    },
    setAppInformationStatus (state, payload) { state.appStoreSetting.AppInformationStatus = payload },
    setContactStatus (state, payload) { state.appStoreSetting.ContactStatus = payload },
    // setScreenshotStatus (state, payload) { state.appStoreSetting.ScreenshotStatus = payload },
    // setScreenShotControlNo (state, payload) { state.screenShotControlNo = payload },
    // removeScreenShot (state, payload) {
    //   if (payload === 1) {
    //     state.appStoreSetting.Screenshot1Filename = null
    //   } else if (payload === 2) {
    //     state.appStoreSetting.Screenshot2Filename = null
    //   } else if (payload === 3) {
    //     state.appStoreSetting.Screenshot3Filename = null
    //   } else if (payload === 4) {
    //     state.appStoreSetting.Screenshot4Filename = null
    //   }
    // },
    setisCorrectionPeriod (state, payload) {
      let lang = localStorage.getItem('language').toUpperCase()
      moment.locale(lang)
      state.LastStartPublishingDate = moment(state.publishingAppData.LastPublishingProcessStartDate)
      state.LastStartPublishingDate = lang === 'DE' ? state.LastStartPublishingDate.format('DD. MMMM YYYY | hh:mm') + payload.strtime : state.LastStartPublishingDate.format('MMMM DD, YYYY | hh:mm a')
      let Currentdate = moment()
      let end = moment(state.publishingAppData.LastPublishingProcessStartDate).add(7, 'days')
      if (state.Countdowntimer && state.Countdowntimer.abort) {
        state.Countdowntimer.abort()
      }
      if (Currentdate < end) {
        state.Countdowntimer = Countdown.timer(end, function (timeLeft) {
          state.Lefthours = timeLeft.hours
          state.Leftminutes = timeLeft.minutes
          state.Leftseconds = timeLeft.seconds
          state.Leftdays = timeLeft.days
        }, function () {
          console.log('Countdown Finished!')
        }
      )
        state.isCorrectionPeriod = false // As per discussion, to hide counter part set to false
      } else {
        state.isCorrectionPeriod = false
      }
    },
    // updateScreenShotInfo (state, payload) {
    //   if (state.screenShotControlNo === 1) {
    //     state.appStoreSetting.Screenshot1Filename = payload
    //   } else if (state.screenShotControlNo === 2) {
    //     state.appStoreSetting.Screenshot2Filename = payload
    //   } else if (state.screenShotControlNo === 3) {
    //     state.appStoreSetting.Screenshot3Filename = payload
    //   } else if (state.screenShotControlNo === 4) {
    //     state.appStoreSetting.Screenshot4Filename = payload
    //   }
    // },
    seticonImageUrl (state, payload) { state.iconImageUrl = payload },
    setsplashScreenUrl (state, payload) { state.splashScreenUrl = payload },
    seticonUrl (state, payload) { state.svgIconUrl = payload },
    addAppName (state, payload) { state.addAppName = payload },
    setIsAppInfochanged (state, payload) { state.IsAppInfochanged = payload },
    setIschanged (state, payload) { state.Ischanged = payload },
    updateCertificateRequest (state) { state.appStoreSetting.AppleAppStoreCertificateRequestStarted = true },
    resetCertificateSettings (state) {
      state.appStoreSetting.AppleAppStoreCertificateFilename = null
      state.appStoreSetting.AppleppStoreProvisioningProfileFilename = null
      state.appStoreSetting.AppleAppStoreCertificatePassword = null
      state.appStoreSetting.AppleAppStorePushNotificationCertificateFilename = null
      state.appStoreSetting.AppleAppStorePushNotificationCertificatePassword = null
      state.appStoreSetting.AppleAppStoreAPNSServerEnvironment = false
      state.appStoreSetting.AppleAppStoreCertificateStatus = false
      state.appStoreSetting.AppleAppStoreCertificateRequestStarted = false
    },
    setAppleAppStoreCertificateFilename (state, payload) {
      state.appStoreSetting.AppleAppStoreCertificateFilename = payload
    },
    setGoogleFirebaseServicesJSONUploaded (state, payload) {
      state.appStoreSetting.GoogleFirebaseServicesJSONUploaded = payload
    },
    setAppleppStoreProvisioningProfileFilename (state, payload) {
      state.appStoreSetting.AppleppStoreProvisioningProfileFilename = payload
    },
    setAppleAppStorePushNotificationCertificateFilename (state, payload) {
      state.appStoreSetting.AppleAppStorePushNotificationCertificateFilename = payload
    },
    setPublishInitial (state, payload) {
      state.pubslishiOS = payload.iOS
      state.publishAndroid = payload.Android
    },
    setpublishingAppData (state, payload) {
      state.publishingAppData = payload
    },
    async saveNativeAppInfo (state, payload) {
      if (state.subscriptionConfiguration.AppSplashscreenStatus) {
        if (!state.subscriptionConfiguration.AppSplashscreenCustomSplashscreen) {
          state.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage = state.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage ? parseInt(state.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage.toString().indexOf('.png') ? state.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage.toString().replace('.png', '') : state.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage) : ''
        }
        let appSplashUrl = payload + '/assets/00-app-splashscreen.png?' + new Date().getTime()
        state.appSplashUrl = 'url(' + appSplashUrl + ')'
      }
      if (state.subscriptionConfiguration.AppIconStatus) {
        if (!state.subscriptionConfiguration.AppIconCustomIcon) {
          state.subscriptionConfiguration.AppIconSelectedBackgroundImage = state.subscriptionConfiguration.AppIconSelectedBackgroundImage ? parseInt(state.subscriptionConfiguration.AppIconSelectedBackgroundImage.toString().indexOf('.png') ? state.subscriptionConfiguration.AppIconSelectedBackgroundImage.toString().replace('.png', '') : state.subscriptionConfiguration.AppIconSelectedBackgroundImage) : ''
        }
        let appIconUrl = payload + '/assets/00-app-icon.png?' + new Date().getTime()
        state.appIconUrl = 'url(' + appIconUrl + ')'
      }
      state.subscriptionConfiguration.PublishedAppNameStatus = state.subscriptionConfiguration.PublishedAppName && state.subscriptionConfiguration.PublishedAppName.length > 0
      state.subscriptionConfiguration.AppStoreAppIdStatus = state.subscriptionConfiguration.AppStoreAppId && state.subscriptionConfiguration.AppStoreAppId.length > 0
      state.subscriptionConfiguration.VersionStatus = state.subscriptionConfiguration.VersionMajorNumber && state.subscriptionConfiguration.VersionMajorNumber > 0
      await api.AppPublishing.saveSubscriptionsConfigurations(state.subscriptionConfiguration)
    }
  },
  actions: {
    async populateAppPublishingData ({ commit, rootGetters, state }) {
      const publishingData = await api.AppPublishing.getAppPublishingData(rootGetters.activeSubscriptionId)
      commit('setpublishingAppData', publishingData[0])
      commit('setPublishInitial', {iOS: rootGetters.subscription.AppleAppStore_Published, Android: rootGetters.subscription.GooglePlay_Published})
      const appStoreSetting = await api.AppPublishing.getSubscriptionsAppStoreSettings(rootGetters.activeSubscriptionId)
      const iconBackgroundImages = await api.AppPublishing.getBackgroundImages()
      // const splashBackgroundImages = await api.AppPublishing.getBackgroundImages()
      const configuration = await api.AppPublishing.getSubscriptionConfiguration(rootGetters.activeSubscriptionId)
      const appCategories = await api.AppPublishing.getAppCategories({ 'CategoryID': 1, 'Language': 'EN' })
      const countriesResponse = await api.system.getCountriesInfo(rootGetters.user.Language)
      if (!rootGetters.isPlusPackage) {
        commit('setisCorrectionPeriod', rootGetters.language)
      } else {
        state.isCorrectionPeriod = false
      }
      commit('setAppStoreSetting', appStoreSetting[0])
      commit('setIconBackgroundImages', iconBackgroundImages)
      commit('setSplashBackgroundImages', iconBackgroundImages)
      commit('setSubscriptionConfiguration', configuration[0])
      commit('setAppCategories', appCategories)
      commit('setAppCountries', countriesResponse)
      if (rootGetters.subscriptionConfiguration.AppSplashscreenStatus) {
        let splashScreenUrl = rootGetters.domainSettings.AppsFTPURL + '.system/app_splashscreen_backgrounds/thumbnail/' + state.splashBackgroundImages[configuration[0].AppSplashscreenSelectedBackgroundImage - 1]
        let appSplashUrl = rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID + '/assets/00-app-splashscreen.png?' + new Date().getTime()
        commit('setappSplashUrl', 'url(' + appSplashUrl + ')')
        if (rootGetters.subscriptionConfiguration.AppSplashscreenCustomSplashscreen) {
          splashScreenUrl = appSplashUrl
        }
        commit('setsplashScreenUrl', 'url(' + splashScreenUrl + ')')
      } else {
        let appSplashUrl = require('@/assets/images/app_splashscreen_placeholder.png')
        commit('setappSplashUrl', 'url(' + appSplashUrl + ')')
      }
      if (rootGetters.subscriptionConfiguration.AppIconStatus) {
        let AppSplashscreenSelectedIcon = configuration[0].AppSplashscreenSelectedIcon ? configuration[0].AppSplashscreenSelectedIcon.split('/') : null
        let iconUrl = ''// rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID + '/assets/' + configuration[0].AppSplashscreenSelectedIcon
        if (AppSplashscreenSelectedIcon && AppSplashscreenSelectedIcon.length > 1) {
          iconUrl = rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID + '/assets/' + AppSplashscreenSelectedIcon[1]
        }

        let appIconUrl = rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID + '/assets/00-app-icon.png?' + new Date().getTime()
        let iconImageUrl = rootGetters.domainSettings.AppsFTPURL + '.system/app_icon_backgrounds/thumbnail/' + state.iconBackgroundImages[configuration[0].AppIconSelectedBackgroundImage - 1]
        if (rootGetters.subscriptionConfiguration.AppIconCustomIcon) {
          iconImageUrl = appIconUrl
        }
        commit('setappIconUrl', 'url(' + appIconUrl + ')')
        commit('seticonImageUrl', 'url(' + iconImageUrl + ')')
        commit('seticonUrl', 'url(' + iconUrl + ')')
      } else {
        let appIconUrl = require('@/assets/images/app_icon_placeholder.png')
        commit('setappIconUrl', 'url(' + appIconUrl + ')')
      }
    },
    async resetCertificateValues ({ commit, rootGetters }) {
      commit('resetCertificateSettings')
      await api.AppPublishing.saveAppStoreSettings(rootGetters.appStoreSetting, rootGetters.subscription.Subscription_GUID)
    },
    async publishApp ({ commit, rootGetters }, payload) {
      const publishingAppResult = await api.AppPublishing.PublishApp(payload)
      if (publishingAppResult.status === 'complete') {
        commit('setpublishProcessstatus', 100)
      }
    },
    setPreviousComponentForBack ({ commit }, payload) {
      commit('setComponentValues', payload)
    },
    async saveNavigate ({ commit, rootGetters, getters, state }) {
      let result = null
      if (rootGetters.currentComponent === 'Splashscreenview' && (rootGetters.Ischanged || !rootGetters.subscriptionConfiguration.AppSplashscreenCustomSplashscreen)) {
        commit('setIschanged', false)
        commit('setIsAppInfochanged', true)
        if (!rootGetters.subscriptionConfiguration.AppSplashscreenCustomSplashscreen && rootGetters.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage) {
          let AppSplashscreenSelectedIcon = rootGetters.subscriptionConfiguration.AppSplashscreenSelectedIcon ? rootGetters.subscriptionConfiguration.AppSplashscreenSelectedIcon.split('/') : null
          let createimageparm = {
            AppIconImageName: state.splashBackgroundImages[rootGetters.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage - 1], // rootGetters.subscriptionConfiguration.AppSplashscreenSelectedBackgroundImage,
            IconFolder: AppSplashscreenSelectedIcon ? AppSplashscreenSelectedIcon[0] : null,
            IconName: AppSplashscreenSelectedIcon ? AppSplashscreenSelectedIcon[1] : null,
            ImageFullsize: 'fullsize',
            IconType: AppSplashscreenSelectedIcon ? (rootGetters.subscriptionConfiguration.AppIconOutlinedIcon ? 'outlined' : 'filled') : '',
            IsAppIcon: AppSplashscreenSelectedIcon ? (AppSplashscreenSelectedIcon[1] !== null) : false,
            IsAppName: rootGetters.addAppName,
            IsSplashImage: true,
            AppName: rootGetters.subscriptionConfiguration.PublishedAppName,
            Subscription_GUID: rootGetters.subscription.Subscription_GUID
          }
          let obj = rootGetters.subscriptionConfiguration
          obj.AppSplashscreenStatus = true
          obj.AppSplashscreenFile = 'Splash.png'
          result = await api.AppPublishing.getCreateSplashImage(createimageparm)
          let appSplashUrl = rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID + '/assets/00-app-splashscreen.png?' + new Date().getTime()
          commit('setappSplashUrl', 'url(' + appSplashUrl + ')')
          commit('saveNativeAppInfo', rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID)
          commit('setSubscriptionConfiguration', obj)
        }
      }
      if (rootGetters.currentComponent === 'PublisIconScreen' && rootGetters.Ischanged) {
        commit('setIschanged', false)
        commit('setIsAppInfochanged', true)
        if (!rootGetters.subscriptionConfiguration.AppIconCustomIcon && rootGetters.subscriptionConfiguration.AppIconSelectedBackgroundImage) {
          let AppSplashscreenSelectedIcon = rootGetters.subscriptionConfiguration.AppSplashscreenSelectedIcon ? rootGetters.subscriptionConfiguration.AppSplashscreenSelectedIcon.split('/') : null
          let createimageparm = {
            AppIconImageName: state.iconBackgroundImages[rootGetters.subscriptionConfiguration.AppIconSelectedBackgroundImage - 1], // rootGetters.subscriptionConfiguration.AppIconSelectedBackgroundImage,
            IconFolder: AppSplashscreenSelectedIcon ? AppSplashscreenSelectedIcon[0] : null,
            IconName: AppSplashscreenSelectedIcon ? AppSplashscreenSelectedIcon[1] : null,
            ImageFullsize: 'fullsize',
            IconType: AppSplashscreenSelectedIcon ? (rootGetters.subscriptionConfiguration.AppIconOutlinedIcon ? 'outlined' : 'filled') : null,
            IsAppIcon: AppSplashscreenSelectedIcon ? (AppSplashscreenSelectedIcon[1] !== null) : false,
            IsSplashImage: false,
            Subscription_GUID: rootGetters.subscription.Subscription_GUID
          }
          let obj = rootGetters.subscriptionConfiguration
          obj.AppIconStatus = true
          obj.AppIconFile = 'Icon.png'
          result = await api.AppPublishing.getCreateSplashImage(createimageparm)
          let appIconUrl = rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID + '/assets/00-app-icon.png?' + new Date().getTime()
          commit('setappIconUrl', 'url(' + appIconUrl + ')')
          commit('setSubscriptionConfiguration', obj)
          commit('saveNativeAppInfo', rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID)
        }
      }
      // if (rootGetters.currentComponent === 'PublishNativeAppStoreView' && rootGetters.IsAppInfochanged) {
      //   let screencount = 0
      //   commit('setIsAppInfochanged', false)
      //   if (IsValid(rootGetters.appStoreSetting.ShortAppDescription, true) && IsValid(rootGetters.appStoreSetting.LongAppDescription, true)) {
      //     commit('setAppInformationStatus', true)
      //   } else {
      //     commit('setAppInformationStatus', false)
      //   }
      //   if (IsValid(rootGetters.appStoreSetting.Firstname, true) &&
      //       IsValid(rootGetters.appStoreSetting.Address, true) &&
      //       IsValid(rootGetters.appStoreSetting.Lastname, true) &&
      //       IsValid(rootGetters.appStoreSetting.PostalCode, true) &&
      //       IsValid(rootGetters.appStoreSetting.City, true) &&
      //       IsValid(rootGetters.appStoreSetting.Country, true) &&
      //       IsValid(rootGetters.appStoreSetting.TechnicalContactFirstname, true) &&
      //       IsValid(rootGetters.appStoreSetting.TechnicalContactLastname, true) &&
      //       IsValid(rootGetters.appStoreSetting.TechnicalContactPhone, true) &&
      //       IsValid(rootGetters.appStoreSetting.TechnicalContactEmail, true) &&
      //       IsValid(rootGetters.appStoreSetting.Website, true)) {
      //     commit('setContactStatus', true)
      //   } else {
      //     commit('setContactStatus', false)
      //   }
      //   // if (IsValid(rootGetters.appStoreSetting.Screenshot1Filename, true)) {
      //   //   screencount++
      //   // }
      //   // if (IsValid(rootGetters.appStoreSetting.Screenshot2Filename, true)) {
      //   //   screencount++
      //   // }
      //   // if (IsValid(rootGetters.appStoreSetting.Screenshot3Filename, true)) {
      //   //   screencount++
      //   // }
      //   // if (IsValid(rootGetters.appStoreSetting.Screenshot4Filename, true)) {
      //   //   screencount++
      //   // }
      //   // if (screencount >= 2) {
      //   //   commit('setScreenshotStatus', true)
      //   // } else {
      //   //   commit('setScreenshotStatus', false)
      //   // }
      //   result = await api.AppPublishing.saveAppStoreSettings(rootGetters.appStoreSetting, rootGetters.subscription.Subscription_GUID)
      // }
      if (rootGetters.currentComponent === 'PublishedInfoView') {
        commit('saveNativeAppInfo', rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID)
      }
      if (rootGetters.currentComponent === 'NativeAppInfoView' && rootGetters.IsAppInfochanged) {
        commit('setIsAppInfochanged', false)
        commit('saveNativeAppInfo', rootGetters.domainSettings.AppsFTPURL + rootGetters.subscription.Subscription_GUID)
      }
      // if (rootGetters.currentComponent === 'Screenshotview') {
      //   result = await api.AppPublishing.saveAppStoreSettings(rootGetters.appStoreSetting, rootGetters.subscription.Subscription_GUID)
      // }
      if (rootGetters.currentComponent === 'AppAddCertificatesview') {
        if (rootGetters.appStoreSetting.AppleAppStoreCertificateFilename != null && rootGetters.appStoreSetting.AppleAppStorePushNotificationCertificateFilename != null && rootGetters.appStoreSetting.AppleppStoreProvisioningProfileFilename != null) {
          rootGetters.appStoreSetting.AppleAppStoreCertificateStatus = true
        } else {
          rootGetters.appStoreSetting.AppleAppStoreCertificateStatus = false
        }
        result = await api.AppPublishing.saveAppStoreSettings(rootGetters.appStoreSetting, rootGetters.subscription.Subscription_GUID)
      }
      if (rootGetters.currentComponent === 'AndroidCertificateview') {
        if (rootGetters.appStoreSetting.GoogleFirebaseServicesJSONUploaded && rootGetters.appStoreSetting.GoogleFirebaseSeverKey != null) {
          rootGetters.appStoreSetting.GoogleFirebaseFCMStatus = true
        } else {
          rootGetters.appStoreSetting.GoogleFirebaseFCMStatus = false
        }
        result = await api.AppPublishing.saveAppStoreSettings(rootGetters.appStoreSetting, rootGetters.subscription.Subscription_GUID)
      }
      return result
    },
    async saveAppStoreSettings ({ commit, rootGetters, getters }) {
      await api.AppPublishing.saveAppStoreSettings(rootGetters.appStoreSetting, rootGetters.subscription.Subscription_GUID)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/appPublishing.js